export const FIT_VIEW_PRIORITY = {
  FIRST_PANEL: 1,
  SECOND_PANEL: 2
};
